export const getBoundingClientRect = (node?: HTMLElement) => {
  if (node != null) {
    const isElement = node.nodeType === 1 /* Node.ELEMENT_NODE */
    if (isElement && typeof node.getBoundingClientRect === "function") {
      return node.getBoundingClientRect()
    }
  }
  return { x: 0, y: 0, width: 0, height: 0, top: 0, left: 0 }
}

export const getRect = (node: HTMLElement) => {
  const { x, y, top, left } = getBoundingClientRect(node)
  const width = node.offsetWidth
  const height = node.offsetHeight
  return { x, y, width, height, top, left }
}

export type MeasureLayoutCallback = (
  x: number,
  y: number,
  width: number,
  height: number,
  left: number,
  top: number,
) => void

export const measureLayout = (
  node: HTMLElement,
  relativeToNativeNode: HTMLElement | undefined,
  callback: MeasureLayoutCallback,
) => {
  const relativeNode = relativeToNativeNode ?? (node && node.parentNode)
  if (node && relativeNode) {
    setTimeout(() => {
      const relativeRect = getBoundingClientRect(relativeNode as HTMLElement)
      const { height, left, top, width } = getRect(node)
      const x = left - relativeRect.left
      const y = top - relativeRect.top
      callback(x, y, width, height, left, top)
    }, 0)
  }
}

export const measure = (node: HTMLElement, callback: MeasureLayoutCallback) => {
  measureLayout(node, undefined, callback)
}
